/* External dependencies */
import gql from 'graphql-tag';

export const listServicesQuery = gql`
  query listServices($input: ListServicesInput!) {
    listServices(input: $input) {
      total
      services {
        typename: __typename
        ... on Service {
          id
          logo {
            url
          }
          name_en
          name_ru
          name_ky
          status
          tags
        }
        ... on Category {
          id
          logo {
            url
          }
          name_en
          name_ru
          name_ky
          name_tr
          tags
          popularityScore
          status
        }
      }
    }
  }
`;
